export * from '../src/composites/wui-chip-button/index.js';
//# sourceMappingURL=wui-chip-button.js.map